import React from 'react';
import hyperloopRussia from '../../imgs/hyperloop-russia.jpg';


export default class Hyperloop3 extends React.Component {
  render() {
    return (
      <div className='typography-container'>
        <h1>О Hyperloop давно и много говорят в России. 
</h1>
        <p> С начала 2016 года многие российские официальные лица и предприниматели, начиная от представителей РЖД и заканчивая президентом РФ, говорили об интересе к Hyperloop. </p>
        <p>Москва хочет развивать Hyperloop. Мэр Москвы Сергей Собянин  подписал с Hyperloop One меморандум о сотрудничестве, который предполагает разработку предварительного обоснования строительства сверхскоростной дороги в столице. В рамках подготовки будет оценена целесообразность строительства Hyperloop в Москве, в том числе для развития связей с «новой Москвой» и для транспортного сообщения с аэропортами. </p>
        <p>Минтранс планирует построить ветку Hyperloop на Дальнем Востоке.</p>
        <p>Ранее о своем интересе к Hyperloop объявили “Российские железные дороги”. Специалисты РЖД сформировали рабочую группу вместе с компанией Hyperloop One для изучения данной технологии и обсуждения возможного сотрудничества. В частности, рассматривается возможность использования сверхзвуковых поездов для грузовых перевозок в России.</p>
        <p>К 2021 году Hyperloop One планирует запустить три функционирующих ветки Hyperloop. Пока что неизвестно, в каких странах это произойдет, но, если первые проекты окажутся успешными, технология может изменить транспортную систему во всем мире.</p>
        <p>Рекордные скорости при относительно небольших затратах открывают новые возможности по транспортировке людей и грузов. Это особенно актуально для России – самой протяженной страны в мире, с огромным, но пока нереализованным, потенциалом инфраструктуры.</p>
        <p align='center'>
            <img className='responsive-img' alt='hyperloop-russia' src={hyperloopRussia} />
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/docs/Hyperloop-3.js